import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Footer from '../components/Footer/Footer'
import OneColumnB from '../components/OneColumnB/OneColumnB'
import OneColumnA from '../components/OneColumnA/OneColumnA'
import FAQS from '../components/FAQS/FAQS'
import CompStructure from '../components/Table/CompStructure'
import CompPayment from '../components/Payment/CompPayment'

const Competitive = () => {

    const listItems = [
        ['affiliation: ', 'Member of Illinois Youth Soccer Association(IYSA)'],
        ['ILLOWA: ', 'We Compete in Illinois-Iowa(ILLOWA) League that includes 6 or more matches, held at various location around the Quad City area.'],
        ['Competitive Goal: ', "The aim of being part of a competitive team is to facilitate the comprehensive development of players' skills, propelling their growth both on and off the field."],
    ];

    const compFaq = [
        {
            id: 1, question: 'Cost',
            answer: 'The cost per player for the entire season ranges from $250 to $350. This includes uniform, Illowa and some tournament fees. '
        },
        {
            id: 2, question: 'Practices',
            answer: 'Each team practices a minimum of twice a week.'
        },
        {
            id: 3, question: 'Length of Season',
            answer: <div>
                <ul>
                    <li>Fall: August to end of October. </li>
                    <li>Spring: Late March, early April to the end of May.</li>
                </ul>
            </div> ,
            
            
        },
        {
            id: 4, question: 'Equipment',
            answer: 'If your child has a ball we encourage them to bring it to practices and match day. All players must wear shin guards and soccer boots/cleat to both practices and matches. Practices and matches are played in all weather conditions, minus lighting. We encourage players and coaches to bring weather permitting gear.'
        },
        {
            id: 5, question: 'Try-outs',
            answer: 'Try-outs happen every year, typically during the first week of June. Your son or daughter will be notified by the coaching staff if they made the competitive team or provide further development assistance.'
        },
    ]

    const compTableData = [
        { age: "U13-U14", matchLength: "2X 30 minute", ballSize: "5", teamSize: "11v11", offsideRule: "Yes", headers: "Yes" },
        { age: "U11-12", matchLength: "2X 30 minute", ballSize: "4", teamSize: "9v9", offsideRule: "Yes", headers: "No" },
        { age: "U9-U10", matchLength: "2X 25 minute", ballSize: "4", teamSize: "7v7", offsideRule: "yes", headers: "No" },
      ]


    return (
        <div>
            <Navbar />
            <div className="app__background-bk section__padding" >
                <div className="app__content">
                    <h1 className="headtext__roboto">Competitive</h1>
                </div>
                <div style={{ paddingBottome: '2rem' }}>
                    <OneColumnB
                        subtitle="Develop to Compete"
                        paragraph="Our competitive program has been a part of OSUSC for many years - often referred to as travel soccer. Competitive program players try out in early June for team selections that will play the following fall and spring."
                    />
                </div>
                <div style={{ paddingTop: '2rem', paddingBottom: '3rem' }}>
                    <OneColumnA
                        subtitleA="Key Insights"
                        items={listItems}
                    />
                </div>
                <div style={{paddingTop: '2rem'}}>
                    <CompStructure compData={compTableData}/>
                </div>
                <div className="app__faq app__background-bk">
                    <FAQS faqTitle="Competitive FAQ's" faqs={compFaq} />
                </div>
                <div style={{paddingTop: '2rem'}}>
                    <CompPayment />
                </div>

            </div>
            <div>
                <Footer />
            </div>
        </div>
    )
}

export default Competitive